import { useQuery } from 'react-query'

import { QueryKeys } from '../../../../../enums/queryKeys'
import { fetchVatDeclarationPayments } from '../../../query-api'

export const useVatDeclarationPayments = (vatDeclarationsPeriodId: string) => {
  const { data, isLoading: isLoadingPayments } = useQuery(
    [QueryKeys.VatDeclarationsPayments, vatDeclarationsPeriodId],
    () => fetchVatDeclarationPayments(vatDeclarationsPeriodId),
    {
      enabled: !!vatDeclarationsPeriodId,
    },
  )

  return { isLoadingPayments, vatDeclarationPayments: data?.salesTaxPayments }
}
